import {useCallback, useState} from 'react';

const MIN_ZOOM = 1;
const MAX_ZOOM = 1.5;
const ZOOM_STEP = 0.1;
export const DEFAULT_ZOOM = 1.0;

export function useZoom() {
  const [zoom, setZoom] = useState(DEFAULT_ZOOM);

  const zoomIn = useCallback(() => {
    setZoom((prev) => Math.min(MAX_ZOOM, parseFloat((prev + ZOOM_STEP).toFixed(1))));
  }, []);

  const zoomOut = useCallback(() => {
    setZoom((prev) => Math.max(MIN_ZOOM, parseFloat((prev - ZOOM_STEP).toFixed(1))));
  }, []);

  return {zoom, zoomIn, zoomOut};
}
